<template>
    <div id="editContentSlide" v-if="!isHidden">
        <div class="overlayFullscreen">
            <div class="overlayContainer">
                
                <OverlayHeader v-bind:title="title"/>

                <div class="contentWrapper">
                    <div class="left">
						<h3 class="headline">{{headline}}</h3>
                        <img v-if="!isVideo" v-bind:src="getImage"/>
						<video v-else v-bind:src="getVideo" controls/>
                        <p>{{getFileName}}</p>
                    </div>

                    <Notes class="middle" 
                        v-bind:title.sync="slide.title" 
                        v-bind:text.sync="slide.text" />

                    <div class="right">
                        <h3 class="headline">Tags</h3>
                        <div class="tags" v-bind:key="tag.id" v-for="tag in tags">
                            <Tag v-bind:tag="tag" v-bind:isSelected="isSelected(tag)" @onClicked="onTagSelected(tag)" />
                        </div>
                    </div>
                </div>

                <div class="saveCancelButtons">
                    <div class="button" v-on:click="onSave">
                        <p>Speichern</p>
                    </div>
                    <div class="button" v-on:click="isHidden=true">
                        <p>Abbrechen</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from '@/services/EventBus.js';
import ContentLoader from '@/services/ContentLoader.js';
import OverlayHeader from '@/components/layout/OverlayHeader.vue';
import Notes from '@/components/layout/Notes.vue';
import Tag from '@/components/tags/Tag.vue';

export default {
    name: "EditContentSlide",
    components: {
        OverlayHeader,
        Notes,
        Tag
    },
    data() {
        return {
            isHidden: true,
			title: '',
			headline: '',
            slide: '',
            tags: [],
			fileName: '',
			isVideo: false
        }
    },
    computed: {
        getImage() {
            if(this.slide && this.slide.media && this.slide.media.formats) {
				let url = (this.slide.media.formats.medium) ? (process.env.VUE_APP_BASE_URL + this.slide.media.formats.medium.url) : (process.env.VUE_APP_BASE_URL + this.slide.media.url);
				return url;
            } else {
                return "";
            }
		},
		getVideo() {
			if(this.slide && this.slide.media) {
				return (process.env.VUE_APP_BASE_URL + this.slide.media.url + '#t=5');
			} else {
                return "";
            }
		},
        getFileName() {
            if(this.slide) {
                return (this.slide.media.name + this.slide.media.ext);
            } else {
                return this.fileName;
            }
        }
    },
    methods: {
        onSave() {
            if(this.slide) {
                EventBus.$emit('onUpdateSlide', this.slide);
            }
            this.isHidden=true;
        },
        isSelected(currentTag) {
            if(!this.slide) return false;
            var found = false;
            this.slide.tags.forEach(tag => {
                if(tag.name === currentTag.name) found = true;
            });
            return found;
        },
        onTagSelected(currentTag) {
            if(!this.slide) return;
            if(this.isSelected(currentTag)) {
                for(var i = 0; i < this.slide.tags.length; i++) { 
                    if(this.slide.tags[i].name === currentTag.name) {
                        this.slide.tags.splice(i,1);
                        break;
                    }
                }
            } else {
                this.slide.tags.push(currentTag);
            }
        }
    },
    async created() {
		this.tags = await ContentLoader.loadTags();
    },
    mounted() {
        EventBus.$on('onEditSlide', slide => {
            this.title = 'Slide bearbeiten';
            this.slide = slide;
			this.isHidden = false;
			this.isVideo = slide.media.mime.includes('video');
			this.headline = this.isVideo ? 'Video' : 'Bild';
        });
    }
}
</script>

<style scoped>
    .overlayContainer {
        display: flex;
        flex-direction: column;
        overflow: auto;
    }

    .overlayContainer .saveCancelButtons {
        position: inherit;
    }

    .contentWrapper {
        display: flex;
        justify-content: space-around;
    }

    .left, .middle, .right {
        height: 100%;
        margin: 10px;
        padding: 5px;
    }

    .left {
        width: 30%;
    }
    .middle {
        width: 30%;
    }
    .right {
        width: 20%;
    }

    .headline {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    img {
        width: 100%;
        object-fit: contain;
        border: 1px solid black;
    }

    video {
        width: 100%;
    }

    .tags {
        width: 100%;
        display: flex;
        align-items: left;
        justify-content: left;
    }
    
</style>